<template>
    <router-view></router-view>
</template>

<script>
  export default{
    name: 'APP',
    beforeCreate(){
    },
    created(){
    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue